import { css, cx } from '@emotion/css';
import colors from '@/theme/colors';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '@/config/constants';
import { BodyMedium, ButtonPrimaryLarge } from '@/design-system';
import { pxToRem } from '@/utils';

type Props = {
  primaryBtnText?: string;
  renderDisclaimer?: boolean;
  renderLoginOption?: boolean;
  handleSubmit: any;
};

const SignUpFooter: React.FunctionComponent<Props> = ({
  primaryBtnText = 'Get Started',
  renderDisclaimer = true,
  renderLoginOption = true,
  handleSubmit,
}) => {
  const navigate = useNavigate();

  return (
    <>
      {renderDisclaimer && (
        <div className={styles.disclaimerContainer}>
          <div>
            <BodyMedium color={colors.slate}>By selecting Get Started, you agree to </BodyMedium>
            <a
              className={styles.linkMe}
              href="https://peachjar.com/privacy-policy-terms.html#terms"
              target="_blank"
              rel="noreferrer"
            >
              Peachjar&apos;s Terms of Service
            </a>
            <BodyMedium color={colors.slate}> and </BodyMedium>
            <a
              className={styles.linkMe}
              href="https://peachjar.com/privacy-policy-terms.html#privacy"
              target="_blank"
              rel="noreferrer"
            >
              Privacy Policy.
            </a>
          </div>
        </div>
      )}
      <div>
        <div onClick={event => handleSubmit(event)}>
          <ButtonPrimaryLarge className={styles.getStarted} fullWidth variant="contained">
            {primaryBtnText}
          </ButtonPrimaryLarge>
        </div>
        {renderLoginOption && (
          <div className={styles.secondaryCTA}>
            <BodyMedium>Have an account? </BodyMedium>
            <a
              href="#"
              className={cx(styles.linkMe, styles.textUnderline)}
              onClick={() => navigate(APP_ROUTES.login)}
            >
              Log In
            </a>
          </div>
        )}
      </div>
    </>
  );
};

const styles = {
  disclaimerContainer: css`
    margin: 114px 0 24px 0;
  `,
  linkMe: css`
    font-family: 'Montserrat Regular';
    font-size: ${pxToRem(14)};
    color: ${colors.jungle} !important;
    &:hover,
    &:focus {
      font-weight: bold;
    }
    cursor: pointer;
  `,
  textUnderline: css`
    text-decoration: underline;
  `,
  secondaryCTA: css`
    color: ${colors.prussian};
    font-family: 'Montserrat Regular', Helvetica, Arial, sans-serif;
    font-size: ${pxToRem(14)};
    margin-top: 12px;
    text-align: center;
  `,
  getStarted: css`
    &.MuiButton-root {
      color: ${colors.white};
      background-color: ${colors.jungle};
      font-size: ${pxToRem(16)};
      text-transform: capitalize;
      border-radius: 8px;
      padding: 12.5px 0px 12.5px 0px;

      letter-spacing: 0.15px;
    }
  `,
};

export default SignUpFooter;
